export default "__VITE_ASSET__9345110b__"